import React from "react";
import ModalV2 from "../../../../../../shared/components/modalV2";
import { TRASHED_DELETED } from "../../../../../../assets";

function DeleteSuccessModal({
  open,
  close,
  message = "Document deleted",
}: {
  open: boolean;
  close: () => void;
  message?: string;
}) {
  return (
    <ModalV2
      isOpen={open}
      isClose={close}
      maxWidth="w-[400px]"
      edges="rounded-xl"
    >
      <div className="px-12 py-10 flex flex-col w-full items-center justify-center gap-y-3">
        <img src={TRASHED_DELETED} className="w-[212px] h-[167px]" alt="" />
        <span className="text-[20px] font-semibold">{message}</span>

        <button
          onClick={close}
          className="bg-[#009444] w-full text-white px-10 py-3 rounded-xl"
        >
          Close
        </button>
      </div>
    </ModalV2>
  );
}

export default DeleteSuccessModal;
